const queuedPlay = (sound: any, soundName: string) => new Promise((resolve) => {
  sound.once('end', resolve);
  sound.play(soundName);
});

class Queue {

  private maxSimultaneously: number;

  private __active: number;

  private __queue: (() => void)[];

  constructor(maxSimultaneously: number = 1) {
    this.maxSimultaneously = maxSimultaneously;
    this.__active = 0;
    this.__queue = [];
  }

  async enqueue<T>(func: () => Promise<T>): Promise<T> {
    if (++this.__active > this.maxSimultaneously) {
      await new Promise<void>((resolve) => {
        this.__queue.push(resolve);
      });
    }

    try {
      return await func();
    } finally {
      this.__active--;
      if (this.__queue.length) {
        const nextResolve = this.__queue.shift();
        if (nextResolve) nextResolve();
      }
    }
  }

}

export { Queue, queuedPlay };
